export interface ManualAward {
    Name: string
    Folder: string
    Description: string
    BadgeID: string
    Coins: number
    XP: number
    AssignedGroups: any[]
    RuleID: number
    AwardLimitValue: number
    AwardLimitPeriod: string
    IsUnlimited: boolean,
    StartDate: Date,
    EndDate: Date,
    AssignedRoles: any[]
}

export interface GivenManualAward {
    BadgeID: number;
    Name: string;
    CoinAmt: number;
    RecipientName: string;
    RecipientRole: string;
    RecipientImageID: number;
    Date: string;
    Date_ForView: string;
    AwarderName: string;
    AwarderRole: string;
    RuleID: number;
    RelatedActionID: number;
}

export interface FullHistoryItems {
    ActionHistoryID: number;
    AwarderName: string;
    AwarderRole: string;
    BadgeID: number;
    CoinAmt: number;
    CompanyID: number;
    Date: Date;
    Date_ForView: string;
    Name: string;
    RecipientID: number;
    RecipientImageID: number;
    RecipientName: string;
    RecipientRole: string;
    RelatedActionID: number;
    RuleID: number;
    XpAmt: number;
}

export interface AwardHistory {
    AwardHistoryType: number;
    FullHistoryItems: FullHistoryItems[];
}

export type AwardHistoryModalCellRederer = FullHistoryItems & {
    columnType: AwardHistoryModalCellRedererType;
    customClass: string;
    primaryText: string;
    secondaryText: string | undefined;
}

export enum AwardHistoryModalCellRedererType {
    AWARD,
    COINS,
    DEFAULT
}

export interface DateRangePresetConfig {
    id: string;
    label: string;
    type: 'relative' | 'custom';
    unit?: 'day' | 'week' | 'month' | 'year';
    unitValue?: number;
    includeToday?: boolean;
    fn?: () => { start: Date; end: Date };
}